import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
} from "@chakra-ui/react";
import {
  PasswordChangedModalContainer,
  PasswordChangedHeading,
  PasswordChangedSubtext,
  ContinueLoginButton,
} from "./style";
import { useTranslation } from "react-i18next";
import SuccessCheckIcon from "./succes-icon";



const PasswordChangedModal = ({ isOpen, onClose }: ChangePasswordProps) => {
    const {t}=useTranslation("common");
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.400" />
      <ModalContent bg="transparent" boxShadow="none" _focus={{ outline: "none" }}>
        <ModalBody display="flex" justifyContent="center" alignItems="center" py={8}>
          <PasswordChangedModalContainer>
            <Flex justify="center" mb="16px">
              <SuccessCheckIcon boxSize="52px" />
            </Flex>
            <PasswordChangedHeading>{t("userProfile.passwordChanged")}</PasswordChangedHeading>
            <PasswordChangedSubtext>
              {t("userProfile.successfulPasswordChange")}
            </PasswordChangedSubtext>

            <ContinueLoginButton onClick={onClose}>
               {t("userProfile.continueLogin")} →
            </ContinueLoginButton>
          </PasswordChangedModalContainer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PasswordChangedModal;
